import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HTTPService } from 'src/app/services/http.service';
import { DateUtils } from 'src/app/system-utils/utils/DateUtils';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';

@Component({
    selector: 'products-download-task-processor',
    templateUrl: './products-download-task-processor.component.html',
    styleUrls: ['./products-download-task-processor.component.scss'],
    standalone: false
})
export class ProductsDownloadTaskProcessorComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogRef:MatDialogRef<any>,
  private http:HTTPService) { }
  value = 0;
  texto="";
  disabled = true;
  ngOnInit(): void {
      let meliItens:Object[] = this.data;
      this.processarExecucao(meliItens);
  }
  
  async processarExecucao(meliItens: Object[]) {
    const filePercent = 100 / (meliItens.length - 1);
    let i = 1;
    
      for ( var data of meliItens ){
          
          await this.createProduct(data).then(main=>{
            this.texto = this.texto +DateUtils.getNow() + ' Processado com Sucesso o Anúncio: '+ data['ID'] + " - " + data['DESCRPROD']+"\n";
            this.value =filePercent*i;
            i++;
            
          }).catch(re=>{
            this.value =filePercent*i;
            i++;
          });  
      } 
    

    

    this.disabled = false;
  }

  sair(){
    this.dialogRef.close(null);
  }


  createProduct(meliItem:Object){
    
    return  new Promise((resolve,reject)=>{

      this.texto = this.texto + DateUtils.getNow() + " - Iniciado o processo do Anúncio:"+ meliItem['ID']+"\n";

      let ob = {
        codeCompany :meliItem['CODECOMPANY'],
        method: 'GET',
        serviceName: 'GetItem',
      }
  
      ob['params'] = [{key:'@MLB', value: meliItem['ID']}];
  
      this.http.post(ob,'MeliNotifications/getGenericMeli',false,true,false).subscribe(result=>{
          let resultado = result['resultado'];
          let obdesc = {
            codeCompany : meliItem['CODECOMPANY'],
            method: 'GET',
            serviceName: 'GetItemDesc',
          }
  
          obdesc['params'] = [{key:'@MLB', value: meliItem['ID']}];
  
          this.http.post(obdesc,'MeliNotifications/getGenericMeli',false,true,false).subscribe(result=>{
            let desc = result['resultado'];
            resultado['description'] = desc['plain_text'];
  
            let pro = {
              codeCompany:  meliItem['CODECOMPANY'],
              codeProduct: meliItem['CODEPRODUCT'],
              codeContract: meliItem['CODECONTRACT'], 
              data: resultado,
              type:"update"
            }
        
            pro['CODEMELI'] = meliItem['CODEMELI'];
              
            this.http.post(pro, 'MeliNotifications/createProduct',false,true,false).subscribe(c=>{  
                //this.texto = this.texto + 'Produto relacionado com sucesso.'+'\n';
                resolve("sucesso");
                
            },
            error=>{
              this.texto = this.texto + DateUtils.getNow() + " - " +this.getError(error) + '\n';
              reject();
            })
          },
          error=>{
            this.texto = this.texto + DateUtils.getNow() + " - " +this.getError(error) + '\n';
            reject();
          });  
      },
      error=>{
        this.texto = this.texto + DateUtils.getNow() + " - " +this.getError(error) + '\n';
        reject();
      });
  
    });
    
  }


  getError(error):string{
    
    if ( ObjectUtil.isNotEmpty(error.error)){
      if ( ObjectUtil.isNotEmpty(error.error.message)){
        return error.error.message;
      }
    }
    if ( ObjectUtil.isNotEmpty(error)){
      if ( ObjectUtil.isNotEmpty(error.message)){
        return error.message;
      }
    }

      return "Sem Mensagem de Erro";
  }

}
